export default [
  {
    path: '/main/reporttrackers',
    meta: {
      tag: 'report_trackers',
      name: 'Inventário de Rastreadores',
      breadcrumb: 'Inventário de Rastreadores'
    },
    component: () => import(/* webpackChunkName: "report-trackers" */ '@/views/main/reports/trackers/Index.vue'),
    children: [
      {
        path: '',
        name: 'listtrackers',
        meta: {
          tag: 'report_trackers',
          name: 'Inventário de Rastreadores',
          menu: 'reports',
        },
        component: () => import(/* webpackChunkName: "report-trackers" */ '@/views/main/reports/trackers/List.vue'),
      }
    ]
  }
]